import {Participant} from '../types';
import {ParticipantOnBackend} from './backendTypes';

export const mapParticipantFromBackend = ({
  participant_id,
  names,
  default_name,
  localized_name,
  category_slug,
  subcategory_slug,
  colors,
  abbreviation,
  nation,
  external_participant_ids,
  logo_url,
  logo_url_stroke,
  logo_url_player,
  logo_url_custom,
}: ParticipantOnBackend): Participant => {
  const defaultName = default_name ?? null;
  const sortedNames = defaultName
    ? [defaultName, ...(names ?? []).filter(n => n !== defaultName)]
    : (names ?? []);

  return {
    participantId: participant_id,
    names: sortedNames,
    defaultName,
    localizedName: (localized_name ?? {}) as Participant['localizedName'],
    categorySlug: category_slug,
    subcategorySlug: subcategory_slug ?? null,
    colors: colors ?? null,
    abbreviation: abbreviation ?? null,
    nation: nation ?? null,
    externalParticipantIds: external_participant_ids ?? null,
    logoUrl: logo_url ?? null,
    logoUrlStroke: logo_url_stroke ?? null,
    logoUrlPlayer: logo_url_player ?? null,
    logoUrlCustom: logo_url_custom ?? null,
  };
};
